module.exports = __webpack_public_path__ + "img/slider_vue.c4b0d925.png";